import styled from '@emotion/styled';
import { getImageThumb } from 'lib/utils/platformImage';
import { useTranslate } from '@tolgee/react';

export interface LazadaOfferMessageProps {
  content: Conversation.MsgLazadaOffer;
}

function LazadaOfferMessage(props: LazadaOfferMessageProps) {
  const {
    content: { products, offerAmount, currency, originalAmount },
  } = props;

  const { t } = useTranslate();

  return (
    <Container>
      <header>{t('ViewAppCenter.出价')}</header>
      {products.map((product) => {
        const { itemId, imgUrl, title, saleProperty, skuId, actionUrl } = product;

        return (
          <div key={itemId}>
            <div style={{ backgroundImage: `url(${getImageThumb(imgUrl, 'LAZADA')})` }} />
            <section>
              <a href={actionUrl} target="__blank">
                {title}
              </a>
              <dl>
                <dt>SKU：</dt>
                <dd>{saleProperty}</dd>
              </dl>
              <dl>
                <dt>{t('domain.product.field.skuCode')}：</dt>
                <dd>{skuId}</dd>
              </dl>
            </section>
          </div>
        );
      })}
      <span>
        <del>
          {currency}
          {originalAmount}
        </del>
        {currency}
        {offerAmount}
      </span>
      <footer>{t('scene.chatWorkspace.messageThread.offer.unsupportedPlatform')}</footer>
    </Container>
  );
}

const Container = styled.div`
  max-width: 380px;
  background: var(--fett-bg-panel);
  border-radius: 4px;
  > header {
    padding: 6px 12px;
    font-weight: 500;
    color: #232326;
    border-bottom: solid 1px #f6f6f6;
  }
  > footer {
    padding: 6px 12px;
    border-top: dashed 1px #f6f6f6;
  }
  > div {
    display: flex;
    margin: 8px 12px 0;
    > div {
      flex: 0 0 auto;
      width: 56px;
      height: 56px;
      margin-right: 8px;
      background-size: cover;
      background-repeat: no-repeat;
    }
    > section {
      flex: 1 0 0;
      > a {
        line-height: 16px;
        color: #575658;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      > dl {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        font-weight: normal;
        color: #858587;
        > dd {
          margin-bottom: 0;
        }
      }
    }
  }
  > span {
    margin-left: 76px;
    > del {
      margin-right: 6px;
      color: #858587;
    }
  }
  [data-color-mode='dark'] & > header {
    color: var(--fett-text-primary);
    border-bottom-color: var(--fett-border-default);
  }
  [data-color-mode='dark'] & > footer {
    border-top-color: var(--fett-border-default);
  }
  [data-color-mode='dark'] & > div > section > a {
    color: var(--fett-text-primary);
  }
  [data-color-mode='dark'] & > div > section > dl,
  [data-color-mode='dark'] & > span > del {
    color: var(--fett-text-tertiary);
  }
`;

export default LazadaOfferMessage;
